module.exports = __webpack_public_path__ + "static/media/pronto_thumb_even.6b9e0506.webp";